



























































































import { Component, Vue } from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import {getBaseUrl, getOrgName, getOrgEmail} from "@/lib/org_info";

@Component({
  methods: {getBaseUrl, getOrgName, getOrgEmail},
  components: { Page },
})
class Policy extends Vue {

}

export default Policy;
